import * as alwaysInCacheTableIdList from './alwaysInCacheTableIdList';
import * as mruTableIdList from './mruTableIdList';
import updateAlwaysInCacheTableIds from './updateAlwaysInCacheTableIds';
import { subscribeToRowNotifications, unsubscribeToRowNotifications, } from '../../notifications/rowNotificationsStrategy';
import removeTableFromStore from '../../store-factory/removeTableFromStore';
import { getViewFilterForTable, MailSortHelper, } from 'owa-mail-list-store';
import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';
// MRU has the last 5 used folders
var MRU_TABLES_THRESHOLD = 5;
// Unsubscribe and remove all rows for this table from list view store
// Also remove the table from the store
function onRemoveTable(tableViewId) {
    unsubscribeToRowNotifications(tableViewId);
    removeTableFromStore(tableViewId);
}
export default function updateTablesInCache(tableView) {
    if (tableView.tableQuery.type == 1 /* Search */) {
        throw new Error('updateTablesInCache should never be called for Search table');
    }
    var mailTableQuery = tableView.tableQuery;
    var sortColumn = mailTableQuery.sortBy.sortColumn;
    var sortDirection = mailTableQuery.sortBy.sortDirection;
    // Inbox with All filter, DateTime-Descending Sort is a special case since it should always be in cache
    if (tableView.tableQuery.folderId == folderNameToId('inbox') &&
        getViewFilterForTable(tableView) === 'All' &&
        sortColumn == 0 /* Date */ &&
        sortDirection == MailSortHelper.DESCENDING_SORT_DIR) {
        return updateAlwaysInCacheTableIds();
    }
    return mruTableIdList.update(tableView);
}
export function initializeTablesInCache() {
    alwaysInCacheTableIdList.initialize(subscribeToRowNotifications, onRemoveTable);
    updateAlwaysInCacheTableIds();
    mruTableIdList.initialize(subscribeToRowNotifications, onRemoveTable, MRU_TABLES_THRESHOLD);
}
export function canAddToMruTableIdList() {
    return mruTableIdList.canAddToList();
}
// VSO-18425 - refactor the table caching code as per the new design.
// This function should be just remove after the code refactoring
export function removeFromMruTableIdList(tableViewId) {
    mruTableIdList.remove(tableViewId);
}
//# sourceMappingURL=updateTablesInCache.js.map